import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Phone, Clock, ArrowRight, Sparkles } from "lucide-react";

const BG =
  "https://images.pexels.com/photos/21031387/pexels-photo-21031387.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const TAPTOTABLE_URL = "https://taptotable.co";

export default function ThankYou() {
  return (
    <div className="relative min-h-screen bg-[#050505] text-white">
      <Header />

      <section className="relative overflow-hidden">
        <div
          aria-hidden
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage: `url(${BG})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div aria-hidden className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 via-[#050505]/85 to-[#050505]" />

        <div className="relative mx-auto max-w-3xl px-5 py-20 text-center md:px-12 md:py-28">
          <div className="fade-up inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/30 bg-[#D4AF37]/5 px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">
            <CheckCircle2 className="h-4 w-4" />
            Submission Received
          </div>

          <h1
            data-testid="thankyou-headline"
            className="fade-up delay-1 mt-6 text-4xl font-bold leading-tight tracking-tight sm:text-5xl lg:text-6xl"
          >
            You're <span className="gold-text-gradient">Pre-Qualified</span> for
            Restaurant Funding Options
          </h1>

          <p className="fade-up delay-2 mx-auto mt-6 max-w-2xl text-base text-zinc-300 sm:text-lg">
            A funding specialist may contact you within 1 business day.
          </p>

          <div className="fade-up delay-3 mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-4 text-left sm:grid-cols-2">
            <InfoCard
              icon={<Phone className="h-5 w-5 text-[#D4AF37]" />}
              title="Expect a call soon"
              body="A funding specialist may contact you within 1 business day to review your options."
            />
            <InfoCard
              icon={<Clock className="h-5 w-5 text-[#D4AF37]" />}
              title="Move quickly"
              body="Keep your phone nearby — approvals can move fast."
            />
          </div>
        </div>
      </section>
{/* AMY SECTION */}
<section className="border-t border-white/5 bg-[#070707] px-5 py-16 md:px-12">
  <div className="mx-auto max-w-4xl">
    <div className="rounded-2xl border border-white/10 bg-[#0F0F0F] p-8 sm:p-10">
      <div className="flex flex-col items-center gap-8 text-center md:flex-row md:items-start md:text-left">
        
        <img
          src="/amy.jpg"
          alt="Amy Laughlin"
          className="h-32 w-32 rounded-full object-cover border border-[#D4AF37]/30"
        />

        <div className="flex-1">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#D4AF37]">
            Your Funding Specialist
          </p>

          <h2 className="mt-2 text-2xl font-semibold text-white">
            Amy Laughlin
          </h2>

          <p className="mt-4 text-sm leading-relaxed text-zinc-400 sm:text-base">
            Amy with ARF Financial Services specializes in helping restaurant
            owners and hospitality businesses explore flexible funding options
            for inventory, equipment, expansion, payroll, and working capital.
          </p>

          <div className="mt-4 space-y-3 text-sm leading-relaxed text-zinc-400">
 <p>
  Your request has been forwarded for review. If you have questions or
  would like to learn more about ARF Financial Services and available
  restaurant funding programs, you can contact Amy directly below.
</p>

  <div className="rounded-xl border border-white/10 bg-black/30 p-4">
    <p className="font-medium text-white">
      Amy Laughlin
    </p>

    <p className="mt-1">
      ARF Financial Services
    </p>

   <a
  href="mailto:alaughlin@arffinancial.com"
  className="block mt-2 text-[#D4AF37] hover:underline"
>
  alaughlin@arffinancial.com
</a>

    <a
  href="tel:8324284813"
  className="block mt-1 text-[#D4AF37] hover:underline"
>
  (832) 428-4813
</a>
  </div>
</div>

          <a
            href="https://arffinancial.my.site.com/portal/ARFRegistration?RPId=0034000001cWquyAAC"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center mt-6 text-[#D4AF37] font-medium hover:underline"
          >
            Learn More About ARF →
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
      {/* TAP TO TABLE UPSELL */}
      <section className="border-t border-white/5 bg-[#080808] px-5 py-20 md:px-12 md:py-28">
        <div className="mx-auto max-w-4xl">
          <div className="rounded-2xl border border-[#D4AF37]/20 bg-gradient-to-br from-[#0F0F0F] to-[#080808] p-8 sm:p-12">
            <div className="flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
              <div className="max-w-xl">
                <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-[#D4AF37]">
                  <Sparkles className="h-3.5 w-3.5" />
                  While you wait
                </p>
                <h2 className="mt-3 text-2xl font-semibold tracking-tight sm:text-3xl">
                  Want more customers while you wait?
                </h2>
                <p className="mt-3 text-sm text-zinc-400 sm:text-base">
                  TapToTable helps local businesses turn walk-ins into repeat
                  customers — automatically. Capture leads with a tap, send
                  promos, and grow.
                </p>
              </div>
              <Button
                asChild
                data-testid="taptotable-cta-button"
                className="h-14 shrink-0 rounded-lg bg-[#D4AF37] px-7 text-base font-bold text-black hover:bg-[#F0C94F] hover:shadow-[0_0_28px_rgba(212,175,55,0.45)] transition-all"
              >
                <a href={TAPTOTABLE_URL} target="_blank" rel="noreferrer">
                  Get More Customers
                  <ArrowRight className="ml-1 h-4 w-4" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

function InfoCard({ icon, title, body }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-[#0F0F0F] p-6">
      <div className="flex h-10 w-10 items-center justify-center rounded-lg border border-[#D4AF37]/30 bg-[#D4AF37]/5">
        {icon}
      </div>
      <h3 className="mt-4 text-lg font-semibold text-white">{title}</h3>
      <p className="mt-1.5 text-sm leading-relaxed text-zinc-400">{body}</p>
    </div>
  );
}
